import React from 'react';
import NumberInput from '../../../../../Components/Form/Inputs/NumberInput';
import RegexValidators from '../../../../../Core/Validation/RegexValidators';
import useLanguage from '../../../../../Services/Language/useLanguageHook';
import styles from '../DairyRevenueProtection.module.scss';
import { DairyRevenueProtectionCalculationInputs } from '../DairyRevenueProtectionDefinitions';

interface IDairyRevenueProtectionDeclaredShareInputProps {
    calculationInputs: DairyRevenueProtectionCalculationInputs;
    setCalculatorInputs: (value: DairyRevenueProtectionCalculationInputs) => void;
}

const DairyRevenueProtectionDeclaredShareInput: React.FC<IDairyRevenueProtectionDeclaredShareInputProps> = (
    props: IDairyRevenueProtectionDeclaredShareInputProps,
) => {
    const [translations] = useLanguage();

    return (
        <div className={styles.dairy_revenue_protection_max_fit_content}>
            <NumberInput
                title={translations.risk.margin.fields.declaredShare}
                required
                value={props.calculationInputs?.declaredSharePercent}
                validation={RegexValidators.PositiveNumberZeroThroughOneHundred}
                handleTextChange={(value) => {
                    if (value < 0 || value > 100) {
                        return;
                    }

                    props.setCalculatorInputs({ ...props.calculationInputs!, declaredSharePercent: +value });
                }}
                errorMessage={translations.risk.text.declaredShareMessage}
                track={{
                    eventCategory: 'InsuranceQuoteEstimator',
                    eventAction: 'DairyDeclaredSharePercentChanged',
                    eventValue: props.calculationInputs?.declaredSharePercent,
                }}
            />
        </div>
    );
};

export default DairyRevenueProtectionDeclaredShareInput;
